"use client";

import React from "react";
import { LayoutDashboard, ShoppingCart, Send } from "lucide-react";
import { useFeatureAccess } from "./FeatureGate";

export default function SideNavForex({ activeTab, onTabChange }) {
  const { flags: featureFlags } = useFeatureAccess("mainFeatures", [
    "buyForex",
    "sellForex",
    "withdrawForex",
    "depositForex",
  ]);

  const navItems = [
    { id: "overview", label: "Overview", icon: LayoutDashboard },
    (featureFlags?.buyForex || featureFlags?.sellForex) && {
      id: "buy-sell",
      label: "Buy / Sell",
      icon: ShoppingCart,
    },
    (featureFlags?.withdrawForex || featureFlags?.depositForex) && {
      id: "send-receive",
      label: "Send / Receive",
      icon: Send,
    },
    // { id: "withdraw-deposit", label: "Withdraw / Deposit", icon: Banknote },
    // { id: "80eightpay", label: "80eight Pay", icon: CreditCard },
  ].filter(Boolean);

  return (
    <nav className="flex flex-col py-10 px-6 space-y-3">
      {navItems.map(({ id, label, icon: Icon }) => (
        <button
          key={id}
          onClick={() => onTabChange(id)}
          className={`flex items-center gap-3 text-left px-4 py-2 rounded-full max-w-[290px] transition-colors ${
            activeTab === id
              ? "bg-gradient-to-r from-pink-500 to-purple-500 text-white h-10 font-semibold"
              : "text-gray-600 hover:bg-gray-100"
          }`}
        >
          <Icon size={18} />
          <span className="text-sm">{label}</span>
        </button>
      ))}
    </nav>
  );
}
